import type { CardHooks } from "./registry";

/**
 * No Time — Light Slash A/D.
 *
 * Stats / keywords are pure data:
 *   - Attack: Power 2, Chain
 *   - Defend: Dodge 2
 *
 * Counter ability ("if opponent uses a weapon attack, silence all their
 * attack keywords for THIS attack only") is fully data-driven via
 * `counterRules`:
 *   - trigger.cardKinds = ["equipment"]   ← matches equipment-source attacks
 *   - effect: kind="remove-keyword", target="popup-attack", keyword=""
 *     (empty keyword + popup-attack mode triggers
 *     `silenceAllAttackKeywords` in the applyPopupEffectToSlot remove-
 *     keyword branch — see playtestEngine.ts.)
 *
 * No engine hook needed, but we register an empty hooks object so future
 * cross-cutting card behaviour (e.g. a "first-use" rider) has a place to
 * land without restructuring the registry.
 */
export const noTime: CardHooks = {};
